import { render, staticRenderFns } from "./product-dimensions-modal.vue?vue&type=template&id=5c1c1a68&"
import script from "./product-dimensions-modal.vue?vue&type=script&lang=js&"
export * from "./product-dimensions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports